import { makeStyles } from "tss-react/mui"
import { Card, Typography, Box, Divider, IconButton, Stack, Menu, MenuItem } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBagShopping, faEllipsisV } from "@fortawesome/pro-solid-svg-icons"
import { PurchaseOrder } from "../../../weekMenuTypes"
import { useDateTime } from "../../../../../../localization/useDateTime"
import { useMoney } from "../../../../../../currency/useMoney"
import { toDinero } from "../../../../../../currency/currencyLib"
import { CheckInReminderCard } from "./CheckInReminder"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { useState } from "react"
import { Receipt, ReceiptDialog } from "../../../../../../receipt/pages/ReceiptDialog"
import { tailwindPalette } from "../../../../../../theme/tailwindPalette"

const useStyles = makeStyles()(() => ({
    card: {
        borderRadius: ".5rem",
        backgroundColor: "#fff",
        padding: "1rem",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
        width: "100%",
    },
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: ".5rem",
    },
    divider: {
        margin: ".75rem 0",
    },
    iconWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: ".5rem",
        padding: ".7rem",
        width: "2.5rem",
        height: "2.5rem",
        color: tailwindPalette.amber[900],
        backgroundColor: tailwindPalette.amber[200],
    },
    menu: {
        "& .MuiPaper-root": {
            width: "10rem",
        },
    },
}))

export function PurchasesCard({
    purchase,
    purchases,
}: {
    purchase: PurchaseOrder
    purchases: ReadonlyArray<PurchaseOrder>
}) {
    const { classes } = useStyles()
    const dateTimeFactory = useDateTime()
    const moneyFactory = useMoney({})
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const [receipt, setReceipt] = useState<Receipt>()

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleMenuClose = () => {
        setAnchorEl(null)
    }

    const handleShowReceipt = () => {
        setReceipt({
            orderId: purchase.id,
            orderUid: purchase.uid,
            orderType: purchase.orderType,
        })
        handleMenuClose()
    }

    return (
        <Card className={classes.card}>
            {purchase.receipt?.checkIn?.isValid && (
                <CheckInReminderCard
                    onLearnMoreClick={() => {
                        /*todo*/
                    }}
                />
            )}
            <Stack direction="row" spacing="1rem" alignItems="start">
                <Box className={classes.iconWrapper}>
                    <FontAwesomeIcon icon={faBagShopping} />
                </Box>
                <Box width="100%">
                    <Box className={classes.header}>
                        {/*<LocalizedEnum base="user-home-upcoming-purchase-card-title" enumValue={purchase.orderType}>*/}
                        <Typography variant="subtitle1">{purchase?.displayName}</Typography>
                        {/*</LocalizedEnum>*/}
                        <IconButton size="small" onClick={handleMenuOpen}>
                            <FontAwesomeIcon icon={faEllipsisV} />
                        </IconButton>
                    </Box>

                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                        className={classes.menu}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                        <LocalizedStrict id="user-home-canteen-upcoming-orders-receipt-item">
                            <MenuItem onClick={handleShowReceipt}>Receipt</MenuItem>
                        </LocalizedStrict>
                    </Menu>
                    {purchase?.deliveries?.length > 0 && (
                        <Typography variant="body2" color="textSecondary">
                            {dateTimeFactory.formatDate(dateTimeFactory.fromApi(purchase.deliveries[0].deliveryTime))}
                        </Typography>
                    )}

                    <Divider className={classes.divider} />

                    <Typography variant="body2" color="textSecondary">
                        {moneyFactory.format(toDinero(purchase.amount))}
                    </Typography>
                </Box>
            </Stack>
            {receipt && (
                <ReceiptDialog
                    receipt={receipt}
                    orders={purchases}
                    open={receipt !== undefined}
                    onClose={() => setReceipt(undefined)}
                />
            )}
        </Card>
    )
}
